import React, { useEffect, useState } from "react"
import "./EditProgram.scss"
import { useLocation, useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { InputText } from "primereact/inputtext"
import UniversityApi from "Api/UniversityApi"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Dropdown } from "primereact/dropdown"
import * as Yup from "yup"
import programApi from "Api/programApi"
import { Calendar } from "primereact/calendar"
import { toast, ToastContainer } from 'react-toastify'


const EditProgram = () => {
  document.title = "Edit Program"
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const userData = JSON.parse(localStorage.getItem("userData"))
  const location = useLocation("")
  const program = location?.state
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const refinedProgramData = {
    ...program,
    modeOfStudy: {
      name:
        program?.modeOfStudy?.charAt(0).toUpperCase() +
        program?.modeOfStudy?.slice(1),
      code:
        program?.modeOfStudy?.charAt(0).toUpperCase() +
        program?.modeOfStudy?.slice(1),
    },
    verifiedStatus: {
      name:
        program?.verifiedStatus?.charAt(0)?.toUpperCase() +
        program?.verifiedStatus?.slice(1),
      code:
        program?.verifiedStatus?.charAt(0)?.toUpperCase() +
        program?.verifiedStatus?.slice(1),
    },
    verifiedReason: program?.verifiedReason ? program?.verifiedReason : "",
  }

  const [programData, setProgramData] = useState(refinedProgramData)

  const handleProgramDataChange = (name, value) => {
    setProgramData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors({ ...errors, [name]: "" })
  }
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Program", link: "#" },
    { label: "Edit Program", link: "#" },
  ]

  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    universityDropDown()
    fetchInstituteByUniId(programData?.university?.universityCode)
  }, [accessToken, program])

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
        console.log(error)
      })
  }

  const ValidateProgram = Yup.object().shape({
    programName: Yup.string().required(" Program name is required "),
    duration: Yup.string().required("Duration is required"),
    level: Yup.string().required("Level is required"),
    eligibilityCriteria: Yup.string().required(
      "Eligibility criteria is required",
    ),
    totalSeats: Yup.date()
      .typeError("Invalid Total Seats")
      .required("Total seats are required"),
    tuitionFee: Yup.date()
      .typeError("Invalid Tution Fee")
      .required("Tution fee is required"),
    admissionFee: Yup.string().required("Admission fee is required"),
    scholarships: Yup.string().required("Scholorship is required"),
    intakeYear: Yup.number()
      .typeError("Invalid Year")
      .min(1900, "Year cannot be less than 1900")
      .max(new Date().getFullYear(), "Year cannot be in the future")
      .required("Intake Year fee is required"),
    modeOfStudy: Yup.string()
      .oneOf(["online", "offline", "hybrid"], "Invalid Mode of Study")
      .required("Mode of study  is required"),
    description: Yup.string().required("Description is required"),
    university: Yup.string().required("University is required"),
    institution: Yup.string().required("Institution is required"),
  })

  const updateProgram = () => {
    const { institution, ...otherProgramData } = programData
    const payload = {
      ...programData,
      university: programData?.university?._id,
      modeOfStudy: programData?.modeOfStudy?.name?.toLowerCase(),
      verifiedStatus: programData?.verifiedStatus.name.toLowerCase(),
      institution: programData?.institution?._id,
      programId:programData?._id,
    }

    setLoading(true)
    ValidateProgram.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        programApi
          .updatePorgram(payload, config)
          .then(res => {
            if (res.data.status) {
              setLoading(false)
              setTimeout(() => {
                navigate("/programlist")
              }, 1000)
              toast.success(res.data.message)
              
            }
          })
          .catch(error => {
            setLoading(false)
            console.log(error)
            toast.error(error?.response?.data?.message)
          })
      })
      .catch(err => {
        setLoading(false)
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
      })
  }

  return (
    <div className="edit-Program">
    <ToastContainer/>
      <Row>
        <Col xs="12">
          <div className="program-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Edit Program" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="program-edit-form">
                <div className="program-edit-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={programData.university}
                      onChange={e => {
                        handleProgramDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="Institution">Institution</label>

                  <div className="inp-err">
                    <Dropdown
                      value={programData.institution}
                      onChange={e => {
                        handleProgramDataChange("institution", e.value)
                      }}
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                    />
                    {errors.Institution && (
                      <small className="error">{errors.Institution}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="ProgramName" className="label">
                    Program Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="ProgramName"
                      value={programData.programName}
                      onChange={e =>
                        handleProgramDataChange("programName", e.target.value)
                      }
                      placeholder="Enter Program Name"
                      className="inp-field-box"
                    />
                    {errors.programName && (
                      <small className="error">{errors.programName}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={programData.duration}
                      onChange={e =>
                        handleProgramDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                    {errors.duration && (
                      <small className="error">{errors.duration}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={programData.level}
                      onChange={e =>
                        handleProgramDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                    {errors.level && (
                      <small className="error">{errors.level}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={programData.eligibilityCriteria}
                      onChange={e =>
                        handleProgramDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                    {errors.eligibilityCriteria && (
                      <small className="error">
                        {errors.eligibilityCriteria}
                      </small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={programData.totalSeats}
                      onChange={e =>
                        handleProgramDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                    {errors.totalSeats && (
                      <small className="error">{errors.totalSeats}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={programData.tuitionFee}
                      onChange={e =>
                        handleProgramDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                    {errors.tuitionFee && (
                      <small className="error">{errors.tuitionFee}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={programData.admissionFee}
                      onChange={e =>
                        handleProgramDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                    {errors.admissionFee && (
                      <small className="error">{errors.admissionFee}</small>
                    )}
                  </div>
                </div>
                <div className="program-edit-inp">
                  <label htmlFor="Scholarship" className="label">
                    Scholarship
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="Scholarship"
                      value={programData.scholarships}
                      onChange={e =>
                        handleProgramDataChange("scholarships", e.target.value)
                      }
                      placeholder="Enter Scholarship"
                      className="inp-field-box"
                    />
                    {errors.scholarships && (
                      <small className="error">{errors.scholarships}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="intakeYear" className="label">
                    IntakeYear
                  </label>
                  <div className="inp-err">
                    <Calendar
                      id="intakeYear"
                      value={
                        programData.intakeYear
                          ? new Date(programData.intakeYear, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleProgramDataChange("intakeYear", selectedYear)
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select Intake Year"
                    />

                    {errors.intakeYear && (
                      <small className="error">{errors.intakeYear}</small>
                    )}
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={programData.modeOfStudy}
                      onChange={e =>
                        handleProgramDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                    {errors.modeOfStudy && (
                      <small className="error">{errors.modeOfStudy}</small>
                    )}
                  </div>
                </div>
                <div className="program-edit-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={programData.description}
                      onChange={e =>
                        handleProgramDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>

                {userData.role === "manager" && (
                  <>
                    <div className="program-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={programData.verifiedStatus}
                          onChange={e =>
                            handleProgramDataChange("verifiedStatus", e.value)
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                        {errors.verifiedStatus && (
                          <small className="error">
                            {errors.verifiedStatus}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="program-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={programData.verifiedReason}
                          onChange={e =>
                            handleProgramDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                        {errors.verifiedReason && (
                          <small className="error">
                            {errors.verifiedReason}
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    updateProgram()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditProgram
